import { render, staticRenderFns } from "./PvText.vue?vue&type=template&id=4ec759c0&"
import script from "./PvText.vue?vue&type=script&lang=js&"
export * from "./PvText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports